module.exports = "/_next/static/images/7b8d8ed4bb8c69728275485d53526a4b-holding-device-smile@0.75x.jpg.webp";